var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"row"},[_c('li',[_c('router-link',{attrs:{"to":`/data/ai/prompts/${_vm.prompt.id}`}},[_vm._v(_vm._s(_vm.prompt.name||_vm.prompt.id))]),_vm._v(" "),(_vm.prompt.act==0)?[_vm._v("(отключено)")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }